<template>
    <div>
        <headerNav title="个人信息" />
        <div>
            <van-form @submit="onSubmit">
           
                <van-cell title="头像">
                    <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                    <template #right-icon>
                         <van-uploader :after-read="afterRead">
                                <div style="border-radius:50%;height:25px;width:25px;text-align:center;display: inline-block;">
                                    <van-icon
                                        class-prefix="abc-icon"
                                        name="nvsheng"
                                        :size="25"
                                        v-if="!model.headImg"
                                    />

                                    <img v-if="model.headImg" :src="$baseurl+model.headImg" style="width:100%;height:100%;border-radius:50%;">
                                </div>
                            <van-icon name="arrow" class="search-icon"  :size="16" :style="{'line-height':'25px','vertical-align':model.headImg?'-2px':'0px'}"/>
                         </van-uploader>
                    </template>
                </van-cell>
           
            <van-field
                v-model="model.nick"
                :required="true"
                label="昵称"
                placeholder="请输入昵称"
                :rules="[{ required: true, message: '请输入昵称' }]"
            />
            <van-field name="radio" label="性别">
                <template #input>
                    <van-radio-group v-model="model.sex" direction="horizontal">
                    <van-radio name="0">男</van-radio>
                    <van-radio name="1">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <!-- <van-field
                readonly
                clickable
                name="datetimePicker"
                :value="value"
                label="生日"
                placeholder="点击选择时间"
                @click="showPicker = true"
            />
            <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
                type="date"
                title="选择年月日"
                @confirm="onConfirm"
                :max-date="maxDate"
                :min-date="minDate"
                @cancel="showPicker = false"
            />
            </van-popup> -->
            <van-field
                v-model="model.signature"
                rows="2"
                autosize
                label="个人签名"
                type="textarea"
                maxlength="15"
                placeholder="请输入个人签名"
                show-word-limit
            />
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
            </van-form>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            showPicker:false,
            minDate:new Date(1970,1,1),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            message:'',
            value:undefined,
            radio:0,
            username:'',
            model:
            {
                headImg:'',
                nick:'',
                sex:'0',
                signature:''
            }
        }
    },
    created(){
        this.ajax.post('/api/services/app/PhoneMemberPersonal/QueryPersonal').then(x=>
        {
            if(x.result)
            {
                this.model=x.result;
                this.model.sex=this.model.sex+'';
            }
        })
    },
    methods:{
        afterRead(file)
        {
            var formData = new FormData();
            formData.append("file",file.file);
            this.ajax
                .post("/File/SaveCatePic", formData)
                .then((x) => {
                   this.model.headImg=x.result.data[0];
                })
                .catch(() => {
                    
                });
        },
        onSubmit()
        {
            if(!this.model.headImg)
            {
                this.$toast("请上传头像图片");
                return ;
            }
            this.ajax.post('/api/services/app/PhoneMemberPersonal/ModifyPersonal',this.model).then(x=>
            {
                this.$toast('创建成功');
                this.$router.back(-1);
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.van-uploader__input-wrapper{
    width: 100%;
}
</style>